import { useEffect } from "react";
import { hasCookieConsent } from "../../hooks/useCookieConsent";
import { loadGoogleAdsTag, setGoogleAdsConsent } from "../../utils/tracking/googleAdsTag";

export default function ConsentScriptManager() {
  useEffect(() => {
    const apply = () => {
      const marketingAllowed = hasCookieConsent("marketing");
      if (marketingAllowed) loadGoogleAdsTag();
      setGoogleAdsConsent(marketingAllowed);
    };

    apply();
    window.addEventListener("cookieConsentUpdated", apply);
    return () => window.removeEventListener("cookieConsentUpdated", apply);
  }, []);

  return null;
}

